import { SvgIcon, SxProps } from "@mui/material";
import CommentSvg from "jsx:../../../Images/Icons/FontAwesome/light/face-monocle.svg";

export function FaceMonocleIcon(props: SxProps) {
    return <SvgIcon component={CommentSvg} inheritViewBox sx={props} />;
}
